import { getPortalId } from './portalId';
import { createAppLoginUrl, createInternalLoginUrl, redirectTo } from './util/location';
export function redirectOn(predicate, redirectLocation) {
  return (arg, context) => {
    if (predicate(arg, context)) {
      redirectTo(redirectLocation);
      return arg;
    }
    return arg;
  };
}
export const logoutOn401 = (response, context) => redirectOn(res => res.status === 401, context.loadBalancer === 'app' ? createAppLoginUrl(context.location) : createInternalLoginUrl(context.loadBalancer, context.location))(response, context);
export const logoutOnMissingPortalId = (params, context) => {
  var _hubspot;
  // Only check for APP load balancer, as portal ID is required for app auth
  if (context.loadBalancer !== 'app') {
    return params;
  }
  const portalId = ((_hubspot = window.hubspot) === null || _hubspot === void 0 || (_hubspot = _hubspot.portal) === null || _hubspot === void 0 ? void 0 : _hubspot.id) || getPortalId();
  return redirectOn(() => portalId === undefined || portalId === null, createAppLoginUrl(context.location))(params, context);
};